import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Experience Exceptional Dining and Catering Services"} subTitle={"Explore Our Culinary Delights"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Request a Quote"} />

      </div>
    </section>
  );

};

export default Banner;